export const headConstants = {
  healthyWeightTitle: "Noom: Stop dieting. Get life-long results.",
  healthyWeightDescription:
    "Ready to stop dieting? Start Noom - an award-winning weight-loss program designed by psychologists & scientifically proven to create real, sustainable results.",
  homepageHrefLangMappings: [
    { href: "https://www.noom.com/en-GB/", hreflang: "en-gb" },
    { href: "https://www.noom.com/en-AU/", hreflang: "en-au" },
    { href: "https://www.noom.com/en-NZ/", hreflang: "en-nz" },
    { href: "https://www.noom.com/de-DE/", hreflang: "de-de" },
    { href: "https://www.noom.com/es-ES/", hreflang: "es-es" },
    { href: "https://www.noom.com/en-IE/", hreflang: "en-ie" },
    { href: "https://www.noom.com/ja-JP/", hreflang: "ja-jp" },
    { href: "https://noom.co.kr/moneyback.html", hreflang: "ko-kr" },
    { href: "https://www.noom.com", hreflang: "en" },
    { href: "https://www.noom.com/ja/", hreflang: "ja" },
    { href: "https://www.noom.com/de/", hreflang: "de" },
    { href: "https://www.noom.com/es/", hreflang: "es" },
    { href: "https://www.noom.com", hreflang: "x-default" },
  ],
};

// Constants for visitorState property in visitorStatus state
export const visitorLifecycleStates = {
  newVisitor: "newVisitor",
  repeatVisitor: "repeatVisitor",
  lead: "lead",
  activeTrial: "activeTrial",
  activeSubscriber: "activeSubscriber",
  atRiskTrial: "atRiskTrial",
  atRiskSubscriber: "atRiskSubscriber",
  winbackEligible: "winbackEligible",
  unknown: "unknown",
};

// Constants for furthestBuyflowStep property in visitorStatus state
export const surveyStates = {
  mainSurvey: "mainSurvey",
  paymentSurvey: "paymentSurvey",
  signup: "signup",
  unknown: "unknown",
};

export const routeConstants = {
  affiliateNoTrial: "aff-ntrl",
  affiliateNoTrialPromo: "aff-ntrl-prm",
  affiliateTrialNPB: "affiliate-trial-npb",
  app14Day: "app-14-day",
  app14DayFtWeb: "app-14-day-ft-web",
  app14DayFt: "app-14-day-ft",
  app14DayReturning: "app-14-day-returning",
  app14DayWeb: "app-14-day-web",
  dietary: "dietary",
  direct: "_direct",
  emailMain: "email-main",
  emailWinback: "email-winback",
  exsf01: "exsf01",
  exsf01d: "exsf01d",
  hmPaid: "hm-paid",
  ndpp: "ndpp",
  referrals: "referrals",
  rfqa: "rfqa",
  rfqaPromo: "rfqa-promo",
  winback: "winback",
};

export const routesForFastForward = [
  routeConstants.exsf01,
  routeConstants.exsf01d,
  routeConstants.direct,
  routeConstants.winback,
];

export const routesForNoomPremium = [
  routeConstants.exsf01,
  routeConstants.exsf01d,
  routeConstants.direct,
  routeConstants.affiliateNoTrial,
  routeConstants.affiliateNoTrialPromo,
  routeConstants.emailWinback,
  routeConstants.winback,
  routeConstants.emailMain,
];

export const baselineRoutesAndWinback = [
  routeConstants.exsf01,
  routeConstants.exsf01d,
  routeConstants.direct,
  routeConstants.winback,
  routeConstants.affiliateNoTrial,
  routeConstants.affiliateNoTrialPromo,
];

export const coreRoutes = [
  routeConstants.exsf01,
  routeConstants.exsf01d,
  routeConstants.direct,
];

export const coreRoutesAndWinback = [
  routeConstants.exsf01,
  routeConstants.exsf01d,
  routeConstants.direct,
  routeConstants.winback,
];

export const baselineRoutes = [
  routeConstants.exsf01,
  routeConstants.exsf01d,
  routeConstants.direct,
  routeConstants.affiliateNoTrial,
  routeConstants.affiliateNoTrialPromo,
];

export const welcomeToNoomRoutes = [
  routeConstants.exsf01,
  routeConstants.exsf01d,
  routeConstants.direct,
  routeConstants.winback,
  routeConstants.affiliateNoTrial,
  routeConstants.affiliateNoTrialPromo,
  routeConstants.app14DayWeb,
  routeConstants.app14Day,
];

export const NOOM_PREMIUM = "meal-workout-49";

export const OFFERS_PURCHASE_URL = "/api/payment/v2/purchase_add_on/";
export const DISCOUNT_PROMO_CODE = "DISCOUNT25";
export const DISCOUNT_VALIDATION_URL = "/upsell_discounts/validate/";
